import api3RD from "constants/api3RD";

export const menuList = [
    {
        name: "Live Casino",
        icon: "live-casino",
        gametype: "LC",
        child: [
            // === AG (Play ACE Gaming) đã tạm ẩn - không hiển thị & không gọi API AG ===
            // {
            //     name: 'Play ACE Gaming',
            //     gametype: 'LC',
            //     action: api3RD.agBalance,
            //     gameid: '0',
            //     providercode: 'AG',
            //     iconpc: "ag_casino",
            //     money: 1,
            //     actiond: api3RD.agDeposit,
            //     port: api3RD.agLogin,
            //     valSname: 'LiveCasino',
            //     valSvalue: "ag_casino",
            //     golive: true
            // },
            {
                name: "Evolution Gaming",
                gametype: "LC",
                action: api3RD.evolutionBalance,
                gameid: "0",
                providercode: "EVOLUTION",
                iconpc: "evl_casino",
                money: 1,
                actiond: api3RD.evolutionTransfer,
                port: api3RD.evolutionLogin,
                valSname: "LiveCasino",
                valSvalue: "evolution_casino",
                golive: true,
            },
            {
                name: "PRAGMATIC CASINO",
                gametype: "LC",
                action: api3RD.pragmaticBalance,
                gameid: "0",
                providercode: "PRAG",
                iconpc: "pragmatic_casino",
                money: 1,
                actiond: api3RD.pragmaticTransfer,
                port: api3RD.pragmaticLogin,
                valSname: "LiveCasino",
                valSvalue: "pragmatic_casino",
                golive: true,
            },
            {
                name: "WM Casino",
                gametype: "LC",
                action: api3RD.wmBalance,
                gameid: "0",
                providercode: "WM",
                iconpc: "wm_casino",
                money: 1000,
                actiond: api3RD.wmTransfer,
                port: api3RD.wmLogin,
                valSname: "LiveCasino",
                valSvalue: "wm_casino",
                golive: true,
            },
            {
                name: "Sexy Gaming",
                gametype: "LC",
                action: api3RD.sgBalance,
                gameid: "0",
                providercode: "SG",
                iconpc: "sg_casino",
                money: 1,
                actiond: api3RD.sgDeposit,
                port: api3RD.sgLogin,
                valSname: "LiveCasino",
                valSvalue: "sg_casino",
                golive: true,
            },
            {
                name: "SA Gaming",
                gametype: "LC",
                action: api3RD.saBalance,
                gameid: "0",
                providercode: "SA",
                iconpc: "sa_casino",
                money: 1,
                actiond: api3RD.saDeposit,
                port: api3RD.saLogin,
                valSname: "LiveCasino",
                valSvalue: "sa_casino",
                golive: true,
            },
            {
                name: "DG Gaming",
                gametype: "LC",
                action: api3RD.dgBalance,
                gameid: "0",
                providercode: "DG",
                iconpc: "dg_casino",
                money: 1,
                actiond: api3RD.dgTransfer,
                port: api3RD.dgLogin,
                valSname: "LiveCasino",
                valSvalue: "dg_casino",
                golive: true,
            },
            {
                name: "Playtech Casino",
                gametype: "LC",
                action: api3RD.ptBalance,
                gameid: "0",
                providercode: "PT",
                iconpc: "pt-live",
                money: 1, // Playtech 1:1 VND
                actiond: api3RD.ptTransfer,
                port: "loginEntry3rdGame",
                valSname: "LiveCasino",
                valSvalue: "pt_casino", // cờ bật/tắt Live Casino Playtech (slot dùng Slots/pt_slot)
                golive: true,
            },
        ],
    },
    {
        name: "Thể Thao",
        icon: "sport-icon",
        gametype: "SB",
        child: [
            {
                name: "Thể thao IBC2",
                gametype: "SB",
                action: api3RD.ibc2Sport,
                gameid: "0",
                providercode: "IBC2",
                iconpc: "ibc",
                money: 1000,
                actiond: api3RD.ibc2Transfer,
                port: api3RD.ibc2Login,
                valSname: "Sportsbook",
                valSvalue: "ibc2_sport",
                golive: true,
            },
            {
                name: "Thể thao CMD",
                gametype: "SB",
                action: api3RD.cmdSport,
                gameid: "0",
                providercode: "CMD",
                iconpc: "cmd",
                money: 1000,
                actiond: api3RD.cmdSportDeposit,
                port: api3RD.cmdSportLogin,
                valSname: "Sportsbook",
                valSvalue: "cmd_sport",
                golive: true,
            },
            {
                name: "Thể thao BTI",
                gametype: "SB",
                action: api3RD.btiSport,
                gameid: "0",
                providercode: "BTI",
                iconpc: "btisport",
                money: 1,
                actiond: api3RD.btiSportDeposit,
                port: api3RD.btiSportLogin,
                valSname: "Sportsbook",
                valSvalue: "bti_sport",
                golive: true,
            },
        ],
    },
    {
        name: "Slots Game",
        icon: "slot-icon",
        gametype: "SL",
        child: [
            {
                name: "Dragoon Soft",
                gametype: "SL",
                action: api3RD.dsBalance,
                gameid: "0",
                providercode: "DS",
                iconpc: "dragoon-slot",
                money: 1000,
                actiond: api3RD.dsDeposit,
                port: api3RD.dsSLot,
                valSname: "Slots",
                valSvalue: "ds_slot",
                golive: true,
            },
            {
                name: "Habanero",
                gametype: "SL",
                action: api3RD.habaBalance,
                gameid: "0",
                providercode: "HABA",
                iconpc: "habanero-slot",
                money: 1,
                actiond: api3RD.habaDeposit,
                port: api3RD.habaLogin,
                valSname: "Slots",
                valSvalue: "habanero_slot",
            },
            {
                name: "PRAGMATIC SLOT",
                gametype: "SL",
                action: api3RD.pragmaticBalance,
                gameid: "0",
                providercode: "PRAG",
                iconpc: "pragmatic-slot",
                money: 1,
                actiond: api3RD.pragmaticTransfer,
                port: api3RD.pragmaticLogin,
                valSname: "LiveCasino",
                valSvalue: "pragmatic_casino",
                golive: true,
            },
            {
                name: "JILI Slot",
                gametype: "SL",
                action: api3RD.jiliBalance,
                gameid: "0",
                providercode: "JILI",
                iconpc: "jili-slot",
                money: 1, // JILI quy đổi 1:1 VND (backend tự xử lý), số dư trả về là VND
                actiond: api3RD.jiliTransfer,
                port: "loginEntry3rdGame",
                valSname: "Slots",
                valSvalue: "jili_slot",
                golive: true,
            },
            {
                name: "PG Soft",
                gametype: "SL",
                action: api3RD.pgsBalance,
                gameid: "0",
                providercode: "PGSOFT",
                iconpc: "pg-slot",
                money: 1, // PG Soft quy đổi 1:1 VND (backend tự xử lý), số dư trả về là VND
                actiond: api3RD.pgsTransfer,
                port: "loginEntry3rdGame",
                valSname: "Slots",
                valSvalue: "pgs_slot", // sảnh riêng PG Soft
                golive: true,
            },
            {
                name: "Playtech",
                gametype: "SL",
                action: api3RD.ptBalance,
                gameid: "0",
                providercode: "PT",
                iconpc: "pt-slot",
                money: 1, // Playtech quy đổi 1:1 VND (backend tự xử lý), số dư trả về là VND
                actiond: api3RD.ptTransfer,
                port: "loginEntry3rdGame",
                valSname: "Slots",
                valSvalue: "pt_slot", // sảnh riêng Playtech
                golive: true,
            },
        ],
    },
    {
        name: "Game Bài",
        icon: "game-bai-icon",
        gametype: "V8",
        child: [
            {
                name: "V8 Poker",
                gametype: "V8",
                action: api3RD.v8Balance,
                gameid: "0",
                providercode: "V8",
                iconpc: "v8-poker",
                money: 1,
                actiond: api3RD.v8Deposit,
                actionLogin: api3RD.v8Withdraw,
                port: api3RD.v8Login,
                valSname: "Others",
                valSvalue: "v8_poker",
                golive: true,
            },
        ],
    },
    {
        name: "Bắn Cá",
        icon: "game-fish-icon",
        gametype: "FH",
        child: [
            {
                name: "Bắn cá CSG",
                gametype: "FH",
                action: api3RD.dsBalance,
                gameid: "0",
                providercode: "DS",
                iconpc: "icon-ds",
                money: 1000,
                actiond: api3RD.dsDeposit,
                actionLogin: api3RD.dsWithdraw,
                port: api3RD.DSGameBean,
                valSname: "Slots",
                valSvalue: "ds_slot",
                golive: true,
            },
            {
                name: "Bắn cá JILI",
                gametype: "FH",
                action: api3RD.jiliBalance,
                gameid: "0",
                providercode: "JILI",
                iconpc: "jili-fish",
                money: 1, // JILI quy đổi 1:1 VND (backend tự xử lý), số dư trả về là VND
                actiond: api3RD.jiliTransfer,
                port: "loginEntry3rdGame",
                valSname: "Slots",
                valSvalue: "jili_slot",
                golive: true,
            },
        ],
    },
];
